var map = {
	"./decidim/avatar-multiuser.png": 53307,
	"./decidim/brands/facebook.svg": 68243,
	"./decidim/brands/google.svg": 73130,
	"./decidim/brands/twitter-x.svg": 87195,
	"./decidim/cc-badge.png": 59017,
	"./decidim/decidim-logo.svg": 15689,
	"./decidim/default-avatar.svg": 45785,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 60159,
	"./decidim/icons.svg": 96184,
	"./decidim/pattern.png": 69899,
	"./decidim/placeholder-card-g.svg": 20760,
	"./decidim/placeholder-card-l.svg": 74515,
	"./decidim/placeholder.jpg": 64429,
	"./decidim/remixicon.symbol.svg": 2400,
	"./decidim/vendor/social-share-button/douban.svg": 99699,
	"./decidim/vendor/social-share-button/email.svg": 46540,
	"./decidim/vendor/social-share-button/facebook.svg": 73176,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 59516,
	"./decidim/vendor/social-share-button/hacker_news.svg": 23424,
	"./decidim/vendor/social-share-button/linkedin.svg": 59242,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 35539,
	"./decidim/vendor/social-share-button/pinterest.svg": 61338,
	"./decidim/vendor/social-share-button/reddit.svg": 21872,
	"./decidim/vendor/social-share-button/telegram.svg": 56021,
	"./decidim/vendor/social-share-button/tumblr.svg": 24946,
	"./decidim/vendor/social-share-button/twitter.svg": 88489,
	"./decidim/vendor/social-share-button/vkontakte.svg": 74627,
	"./decidim/vendor/social-share-button/wechat.svg": 40814,
	"./decidim/vendor/social-share-button/whatsapp.svg": 60934,
	"./decidim/vendor/social-share-button/x.svg": 21860,
	"./decidim/vendor/social-share-button/xing.svg": 39828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46890;